import { apiConfigurations } from '@/api/apiConfigurations';
import { isFulfilledAction, isPendingAction, isRejectedAction, logError } from '@/helpers';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IApiConfigState, IApiConfiguration, IThunkAPI } from '../types';

const initialState: Readonly<IApiConfigState> = {
  isError: false,
  isSuccess: false,
  isFetching: false,
  clientLogoUrl: '',
  speedTestUrl: '',
  computerTestUrl: '',
  dropBoxSignConfig: undefined,
};

export const fetchClientConfigurations = createAsyncThunk<IApiConfiguration, void, IThunkAPI>(
  'auth/fetch/clientConfigurations',
  async (_, thunkAPI) => {
    try {
      const response = await apiConfigurations.fetchClientConfigurations();
      return response.data;
    } catch (e) {
      logError(e);
      return thunkAPI.rejectWithValue(e.response);
    }
  },
);

export const apiConfigSlice = createSlice({
  name: 'apiConfig',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchClientConfigurations.fulfilled, (state, action) => {
      state.clientLogoUrl = action.payload.clientLogoUrl;
      state.speedTestUrl = action.payload.speedTestUrl;
      state.computerTestUrl = action.payload.computerTestUrl;

      if (action.payload.dropBoxSignConfig) {
        state.dropBoxSignConfig = {
          clientId: action.payload.dropBoxSignConfig.clientId,
          testMode: action.payload.dropBoxSignConfig.testMode,
        };
      }
    }),
      builder.addMatcher(isPendingAction, state => {
        state.isFetching = true;
        state.isError = false;
        state.isSuccess = true;
      });
    builder.addMatcher(isFulfilledAction, state => {
      state.isSuccess = true;
      state.isError = false;
      state.isFetching = false;
    });
    builder.addMatcher(isRejectedAction, state => {
      state.isError = true;
      state.isFetching = false;
      state.isSuccess = false;
    });
  },
});

export default apiConfigSlice.reducer;
